import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  CharacterSpell,
  Spell,
  StoredSpell,
} from "@dndModels";

import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import { CASTING_TIME_MAP } from "@dndModels/Constants";

interface Props {
  spell: Spell | CharacterSpell | StoredSpell;
  backgroundColor?: string;
}

export default function SpellDetails({
  spell,
  backgroundColor = "black"
}: Props) {
  return (
    <Grid container spacing={0} direction="row"
      style={{ border: "1px solid", padding: "4px", backgroundColor }}>
      <Grid
        size={{
          xs: 12
        }}>
        <b>Casting Time: </b><em style={{ fontStyle: "normal" }}>{ spell.casting_times.map(o => CASTING_TIME_MAP[o]) }</em>
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <b>Components: </b><em style={{ fontStyle: "normal" }}>{ spell.components_string }</em>
      </Grid>
      { spell.duration !== "Instantaneous" &&
        <Grid
          size={{
            xs: 12
          }}>
          <b>Duration: </b><em style={{ fontStyle: "normal" }}>{ spell.duration }</em>
        </Grid>
      }
      { spell.range_string.length > 0 && 
        <Grid
          size={{
            xs: 12
          }}>
          <b>Range: </b><em style={{ fontStyle: "normal" }}>{ spell.range_string }</em>
        </Grid>
      }
      <Grid
        size={{
          xs: 12
        }}>
        <DisplayStringWithReplacements display_string={ spell.description } />
      </Grid>
    </Grid>
  );
}
